import HyderabadToofans from '../pages/FixtureResult/Image/Teams/Hyderabad.webp';
import ShrachiBengalTigers from '../pages/FixtureResult/Image/Teams/SHRACHI.webp';
import SgPipers from '../pages/FixtureResult/Image/Teams/Delhi SG Pipers.webp';
import JswSoormaHockeyClub from '../pages/FixtureResult/Image/Teams/JSW.webp';
import VedantaKalingaLancers from '../pages/FixtureResult/Image/Teams/Kalinga Lancer.webp';
import AccordTamilNaduDragons from '../pages/FixtureResult/Image/Teams/Tamilnadu.webp';
import RanchiRoyals from '../pages/FixtureResult/Image/Teams/RoyalRanchi.webp';
import HilGc from '../pages/FixtureResult/Image/Teams/HIL.webp';

export const HOME_TEAM = 'Hyderabad Toofans';

export const TEAM_LOGOS = {
  'Hyderabad Toofans': HyderabadToofans,
  'Shrachi Bengal Tigers': ShrachiBengalTigers,
  'SG Pipers': SgPipers,
  'JSW Soorma Hockey Club': JswSoormaHockeyClub,
  'Vedanta Kalinga Lancers': VedantaKalingaLancers,
  'Accord Tamil Nadu Dragons': AccordTamilNaduDragons,
  'Ranchi Royals': RanchiRoyals,
  'HIL GC': HilGc,
};
